import {
    LICENSE as LICENSE_SHARED,
    resultStateProperties as sharedResultStateProperties,
} from '../shared/CommonConstants';

export const DIBELS8_APPLICATION_SID = '46';

export const LICENSE = {
    ...LICENSE_SHARED,
    TRO: 'TRO',
    DNO: 'DNO',
    AMPLIFY_READING: 'Amplify Reading',
    BURST: 'BURST',
    CKLA_2_EDITION: 'CKLA_2_EDITION',
    OLS: 'OLS',
    OL: 'OL', // re-map for OLS
    DECODING_ONLINE: 'DECODING_ONLINE',
    DO: 'DO', // re-map for DECODING_ONLINE
    SPELLING: 'SPELLING',
    RAN: 'RAN',
    EXPRESS: 'EXPRESS',
    HIDE_ACADIENCE_READING: 'HIDE_ACADIENCE_READING',
    LOUISIANA: 'LOUISIANA',
    SCHEDULER: 'SCHEDULER',
};

export const resultStateProperties = sharedResultStateProperties.concat('growthZones');
